module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0114.jpg?v=eb45c63a";